<template>
  <div v-if="this.$route.params.id == undefined">

    <title-row
      title="QR kód igénylések"
      :breadcrumb-items="[
        {
          text: 'QR kód igénylések',
          disabled: true,
        },
      ]">
      <template #buttons>
        <title-row-button v-if="hasRight('QR_WRITE')" @click="showRequestDialog()">
          <v-icon left>mdi-plus</v-icon>
          Új igénylés
        </title-row-button>
      </template>
    </title-row>


    <v-card flat class="rounded-xl overflow-hidden">
      <v-tabs v-model="tab" align-tabs="center" color="text--primary">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab key="active_requests">Aktív igénylések</v-tab>
        <v-tab key="fulfilled_requests">Felhasznált igénylések</v-tab>
        <!-- <v-tab v-if="$store.state.user.superadmin" key="filled">Minden felhasználó igénylései</v-tab> -->

        <v-tabs-items v-model="tab">
          <v-tab-item key="active_requests" :transition="false">
            <TabRequests :fulfilled="false" @edit="(item) => showRequestDialog(item.id)" @delete="(item) => deleteRequest(item.id)" />
          </v-tab-item>

          <v-tab-item key="fulfilled_requests" :transition="false">
            <TabRequests :fulfilled="true" @edit="(item) => showRequestDialog(item.id)" @delete="(item) => deleteRequest(item.id)" />
          </v-tab-item>

        </v-tabs-items>
      </v-tabs>
    </v-card>

    <RequestDialog
      v-if="requestDialog.visible"
      :request-id="requestDialog.requestId"
      @close="hideRequestDialog"
      @save="requestDialogSaveEventHandler"
    />
  </div>
</template>

<script>
import RequestDialog from './RequestDialog.vue';
import TabRequests from './TabRequests.vue';

export default {
  components: {
    RequestDialog,
    TabRequests
  },

  data() {
    return {
      routeName: 'QrCodeRequestList',
      search: {},
      unapprovedAmount: 0,
      requestDialog: {
        visible: false,
        requestId: null,
      },
      tab: 'active_requests',
    };
  },

  methods: {
    parseSearchQueries() {
      return {};
    },

    showRequestDialog(request = 0) {
      this.requestDialog.visible = true;
      this.requestDialog.requestId = request;
    },

    hideRequestDialog() {
      this.requestDialog.visible = false;
      this.requestDialog.requestId = null;
    },

    async requestDialogSaveEventHandler(request) {
      await this.fetchItems();
      this.dataTable.highlighted = [Number(request.id)];
    },
  },

  computed: {
    searchQueries() {
      return {};
    },
  },
};
</script>
